import React, { useEffect, useState } from 'react';
import { Client, HydrationProvider } from 'react-hydration-provider';
import { useInView } from 'react-intersection-observer';
import ReactPlayer from 'react-player/lazy';

import { ReactComponent as PlayButton } from '../../images/video-play.svg';
import * as styles from './AutoPauseVideo.module.scss';

export const AutoPauseVideo = ({ src, classes = [], controls = false, customThumbnail = null }) => {
  const [thumbnail, setThumbnail] = useState(false);
  const [playing, setPlaying] = useState(false);
  const { ref: videoRef, inView: videoVisible } = useInView({
    threshold: 0.25,
    triggerOnce: false,
  });

  useEffect(() => {
    if (src.includes('wistia') && !thumbnail) {
      fetch(`https://fast.wistia.net/oembed?url=${src}?embedType=async&videoWidth=960`)
        .then((response) => response?.json())
        .then((data) => setThumbnail(data?.thumbnail_url));
    }
  }, [src]);

  useEffect(() => {
    if (!videoVisible) setPlaying(false);
  }, [videoVisible]);

  const thumbnailComponent = (
    <div className={styles.thumbnail}>
      <img src={thumbnail || customThumbnail} loading="lazy" alt="Video thumbnail" width="960" height="540" />
      <PlayButton />
    </div>
  );

  return (
    <HydrationProvider>
      <Client>
        <div className={[...classes, `player-wrapper-${src}`].join(' ')} ref={videoRef}>
          <ReactPlayer
            light={thumbnail || customThumbnail ? thumbnailComponent : false}
            playIcon={<></>}
            className={`react-player-${src}`}
            controls={controls}
            url={src}
            onClickPreview={() => setPlaying(true)}
            onPlay={() => setPlaying(true)}
            onPause={() => setPlaying(false)}
            playing={playing}
            width="100%"
            height="100%"
          />
        </div>
      </Client>
    </HydrationProvider>
  );
};
